module.exports = __webpack_public_path__ + "assets/img/info3.529799be.svg";